module.exports = function(Swiper) {

    if ( document.querySelector('.sc-ss-subservices') ) {
        fSwiper()
    }

    function fSwiper() {
        let swiper = new Swiper('.sc-ss-subservices .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.sc-ss-subservices .swiper-button-next',
                prevEl: '.sc-ss-subservices .swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 28,
                },
                960: {
                    slidesPerView: 1.1,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                }
            }
        });
    }

};